export default [
   {
      path: '/commonality',
      component: () => import( '@/views/loud/commonality/commonality.vue'),
   },
   {
      path: '/commonality/null',
      component: () => import( '@/views/loud/commonality/null.vue'),

   },
   {
      path: '/commonality/content',
      component: () => import( '@/views/loud/commonality/content.vue'),
   },
   {
      path: '/commonality/message',
      component: () => import( '@/views/loud/commonality/message.vue'),
   },
   {
      path: '/commonality/search',
      component: () => import( '@/views/loud/commonality/search.vue'),
   }
]